import { render, staticRenderFns } from "./Route.vue?vue&type=template&id=35235f6b&scoped=true"
import script from "./Route.vue?vue&type=script&lang=js"
export * from "./Route.vue?vue&type=script&lang=js"
import style0 from "./Route.vue?vue&type=style&index=0&id=35235f6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35235f6b",
  null
  
)

export default component.exports